import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import 'rxjs/add/observable/of';

import { environment } from '../../environments/environment';

@Injectable()
export class HomeService {

  private serverUrl = environment.serverUrl;

  constructor(private http: HttpClient) {}

  categoriesListing(): Observable<any> {
    const reqObj = `categories/all`;
    return this.http.get(this.serverUrl + reqObj);
  }

  featuredImages(): Observable<any> {
    const reqObj = 'featureimages/active';
    return this.http.get(this.serverUrl + reqObj);
  }

  featuredImagesAndCategories(date): Observable<any> {
    const reqObj = 'categories/withactivefeatures';
    return this.http.put(this.serverUrl + reqObj, {date: date});
  }
}



// WEBPACK FOOTER //
// ./src/app/services/home.service.ts